
import { IoCartOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchWishlistData } from "../redux/actions/wishlistData";
import { useEffect, useState } from "react";
import { removeFromWishlist } from "../service/addToWishlist";
import { addToCart } from "../service/addToCart";
import { fetchLoggedUser } from "../redux/actions/loggedUserActions";
export default function WishlistPage() {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const [loading, setLoading] = useState(false);
  const {wishlistData=[], wishlisterror,}=useSelector((state)=>state.wishlistState);
  const { user, error } = useSelector(
    (state) => state.loggedUserState
  );
  useEffect(()=>{     
      try {
            setLoading(true);
            dispatch(fetchWishlistData());
          } finally {
            setLoading(false);
          }
  },[dispatch]);

  function formatNumber(value) {
    const num = Number(value);
    return num % 1 === 0 ? num : num.toFixed(2);
  }

const RemoveProduct=(productId)=>{
  dispatch(removeFromWishlist(productId));
}

const AddToCart=(productId)=>{
  dispatch(addToCart(productId));
}

  useEffect(() => {
    const fetchData = async () => {
           dispatch(fetchLoggedUser());  
    };
    fetchData();
  }, [dispatch]);

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h2 className="text-2xl font-semibold text-red-600">Access Denied</h2>
        <p className="mt-2 text-gray-600">You must be logged in to view this page.</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          onClick={() => navigate("/login")}
        >
          Go to Login
        </button>
        
      </div>
    );
  }

  if(wishlisterror)
  {
    return(
      <p className="text-red-600">Wishlisr error : {wishlisterror}</p>
    );
  }

  if (loading) {
    return <p className="text-center mt-10">Loading wishlist products...</p>;
  }

  {error && (
  <p className="text-red-600">
    {typeof error === "string" ? error : error.message || "Something went wrong"}
  </p>
  )}

  return (
    <section className="px-5 md:px-10 xl:px-16 py-10 bg-gray-100 min-h-screen">
       <div className="flex flex-row space-x-2 items-center mb-5" onClick={()=>navigate(-1)}>
          <MdKeyboardBackspace className="text-2xl xl:text-3xl" />
          <h2 className="text-xl xl:text-2xl font-bold text-center">
            My Wishlist
          </h2>
        </div>

      {wishlistData.length === 0 ? (
        <div className="text-center text-gray-600 flex flex-col space-y-4">
          <p>Your Wishlist is empty.</p>
          <Link to="/">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Products</button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {wishlistData.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow rounded p-4 flex flex-col justify-between space-y-2 relative"
            >
              <Link to={`/productdetail/${item.productId}`}>
              <div>
              <div className="relative w-full h-36 flex justify-center items-center">
                <img 
                  src={item.product?.images?.[0].image} 
                  alt={item.productName}
                  className="object-contain h-full"
                />
                <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {formatNumber(item.product?.discountPercent)}% OFF
                </div>
              </div>

              <h2 className="flex flex-row items-center gap-1 text-sm md:text-base xl:text-lg font-semibold whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] md:max-w-[250px] xl:max-w-[220px] 2xl:w-full">
                {item.product?.productName} {item.product?.category?.name} {item.product?.model}
              </h2>
              <p className="text-sm text-gray-600 whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] md:max-w-[250px] xl:max-w-[220px] 2xl:w-full">{item.product?.description}</p>

              <div className="flex space-x-2 items-center justify-between">
                <span className="text-sm font-semibold text-gray-800">
                  ₹{formatNumber(item.product?.discountedPrice)}
                </span>
                <span className="line-through text-gray-500 text-sm">
                  ₹{formatNumber(item.product?.originalPrice)}
                </span>
                {/* <span className="text-sm text-red-600">
                  {item.product?.discountPercent} off
                </span> */}
                <p
                  className={`text-xs md:text-sm font-semibold ${
                  item.stockStatus === "inStock"
                  ? "text-green-600"
                  : item.stockStatus === "lowStock"
                  ? "text-yellow-500"
                  : "text-red-600"
                  }`}
                >
                  {item.stockStatus === "inStock"
                  ? "In Stock"
                  : item.stockStatus === "lowStock"
                  ? "Low Stock"
                  : "Out of Stock"
                  }
                </p>
              </div>
              </div>
              </Link>
              <div className="flex flex-row  gap-3 text-xs md:text-sm">
                <button
                onClick={() => AddToCart(item.productId)}
                className={`flex items-center justify-center bg-[#A63F40] text-white py-1 mt-2 rounded
                 hover:bg-[#852b2c] w-full md:w-1/2
                 ${item.totalStock < 1 ? "cursor-not-allowed bg-opacity-80" : "cursor-pointer"}`}
                 disabled={item.totalStock < 1}
              >
                <IoCartOutline className="mr-2" />
                Add to Cart
              </button>
              <button  onClick={() => RemoveProduct(item.productId)}
               className="flex w-full md:w-1/2 border border-[#A63F40] items-center justify-center text-[#A63F40] py-1 mt-2 rounded hover:font-bold">
                Remove
               </button>
              </div>
              
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
